<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="after-the-bombs-the-cavemen">
<h1>After the Bombs: The Cavemen</h1>
<p>When the bombs dropped, all the homeless people hid in the storm drain. Two women and two men survived, two men did not.</p>
<p>The remaining four decided to hide in the drain for as long as they could, sneaking out in the dead of night to search for food.</p>
<p>Eventually, as the food ran out and they began to feel a bit braver they decided to move away from Fort Calder and to head to Calder City.</p>
<p>They found a van with the keys still in it and fortunately one of the women could drive. They set off from the top of the town heading for the city.</p>
<p>When the van ran out of fuel just a few miles past the turning for Inch Village, the cavemen left the van and went to hide amongst the trees. Having spent most of their time in a storm drain, they felt vulnerable out in the open, so they took cover in the trees to rest, hoping that they were well hidden. They didn’t want to be spotted until they were ready to pounce.</p>
<p>They waited in the trees hoping that someone would come along and they could steal their food or their car, or both from them.</p>
<p>From their vantage point in the trees, the cavemen had a good view of the road. They had watched as Angel drove along the road and as the car shuddered then stopped. As they continued watching, Angel and Madi got out of the car and opened the boot. They took some water and food out of the boot, and it looked like they were going to walk.</p>
<p>As soon as the girl and the child were out of sight, the cavemen descended upon the car. Sure enough the boot had a lot of food and drink in it.</p>
<p>Standing at the back of the car, they stuffed their faces greedily, then they gathered what was left and took it to their hideout in the trees.</p>
<p>Feeling better with full bellies, they lay down to rest, while keeping an eye on the road and listening for vehicles.</p>
<p>As they rested, they heard and then saw a quad bike approach, heading in the direction of Calder City. It looked like a teenage boy who was riding it and he didn’t appear to have any bags or bundles that could be food, so they kept hidden and left him to go on his way.</p>
<p>They continued to watch the road and they saw the boy on the quad bike return and this time he had the girl and the child from the car with him.</p>
<p>The boy and the girl rushed to the boot of the car, presumably to get the food. The cavemen watched as the boy, the girl and the child stopped in their tracks when they saw that the boot was empty.</p>
<p>‘Snooze you lose mate,’ said one cavemen to the others, ‘snooze you lose.’</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch012.vue?39313748